import { graphqlApolloClient } from "../graphql-apollo-client"
import {
  CREATE_ACTIVITIES,
  GET_ACTIVITIES_BY_SUBMISSION,
  GET_ACTIVITY_BY_ID, UPDATE_ACTIVITIES,
  UPDATE_ACTIVITIES_ORDER_INDEX,
  UPDATE_ACTIVITY_ESTIMATED_PARTICIPANTS
} from "./graphql"
import { DELETE_ACTIVITIES } from "./graphql/delete-activities"

export const activityService = activityRepository => {
  /**
   * @param {string} id
   * @return Promise<Activity>
   */
  const getActivityById = async ({ id }) => {
    const result = await graphqlApolloClient.query({
      query: GET_ACTIVITY_BY_ID,
      fetchPolicy: "network-only",
      variables: { id }
    })
    return result.data?.objectivesAndActivitiesTabActivity
  }

  const updateActivitiesOrderIndex = async ({ updatedActivities }) => {
    const result = await graphqlApolloClient.mutate({
      mutation: UPDATE_ACTIVITIES_ORDER_INDEX,
      variables: { data: updatedActivities }
    })

    return result?.data?.UpdateActivitiesOrderIndex
  }

  const updateActivityEstimatedParticipants = async ({ activityId, estimatedParticipants }) => {
    const { data } = await graphqlApolloClient.mutate({
      mutation: UPDATE_ACTIVITY_ESTIMATED_PARTICIPANTS,
      variables: { activityId, estimatedParticipants }
    })

    return data?.UPDATE_ACTIVITY_ESTIMATED_PARTICIPANTS
  }

  const getActivitiesBySubmission = async ({ id }) => {
    const { data } = await graphqlApolloClient.query({
      query: GET_ACTIVITIES_BY_SUBMISSION,
      fetchPolicy: "network-only",
      variables: { id }
    })

    return data?.activitiesBySubmissionId
  }

  const updateActivities = async ({ activities }) => {
    const { data } = await graphqlApolloClient.mutate({
      mutation: UPDATE_ACTIVITIES,
      variables: { activities }
    })

    return data?.updateActivities
  }

  const createActivities = async ({ activities }) => {
    const { data } = await graphqlApolloClient.mutate({
      mutation: CREATE_ACTIVITIES,
      variables: { activities }
    })

    return data?.createActivities
  }

  const deleteActivities = async ({ activityIds }) => {
    const { data } = await graphqlApolloClient.mutate({
      mutation: DELETE_ACTIVITIES,
      variables: { activityIds }
    })

    return data?.deleteActivities
  }


  return {
    getActivityById,
    updateActivities,
    createActivities,
    deleteActivities,
    getActivitiesBySubmission,
    updateActivitiesOrderIndex,
    updateActivityEstimatedParticipants
  }
}


/**
 * @typedef Activity
 * @property {string} id
 * @property {number} goal
 * @property {array.<string>} products
 * @property {MeansOfVerification[]} meansOfVerificationPerMonth
 */

/**
 * @typedef MeansOfVerification
 * @property {string} id
 * @property {number} month
 * @property {number} year
 * @property {number} monthProgress
 * @property {boolean} isRevisionBlocked
 * @property {array.<Document>} verificationDocumentsPerMonth
 */

/**
 * @typedef Document
 * @property {string} id
 * @property {string} url
 * @property {string} name
 * @property {string} type
 */
